import React from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import { Colors } from "../../utils/Colors";

export default function PageShell({ title, subtitle, children, right }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `
          radial-gradient(1200px 600px at 15% 10%, rgba(11,60,63,0.10), transparent 60%),
          radial-gradient(900px 500px at 85% 10%, rgba(8,49,52,0.08), transparent 55%),
          ${Colors.bg.app}
        `,
        py: { xs: 2.5, md: 4 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: right ? "1.15fr 0.85fr" : "1fr",
            },
            gap: 2.5,
            alignItems: "start",
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, md: 3 },
              backgroundColor: Colors.bg.paper,
              border: `1px solid ${Colors.border.light}`,
              borderRadius: 3,
              boxShadow: Colors.shadow.brand,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: Colors.text.title,
                fontWeight: 700,
                letterSpacing: 0.2,
              }}
            >
              {title}
            </Typography>

            {subtitle ? (
              <Typography
                sx={{
                  mt: 0.8,
                  color: Colors.text.muted,
                  fontSize: "0.95rem",
                }}
              >
                {subtitle}
              </Typography>
            ) : null}

            <Box
              sx={{
                mt: 2,
                pt: 2,
                borderTop: `1px solid ${Colors.border.topLine}`,
              }}
            >
              {children}
            </Box>
          </Paper>

          {right ? (
            <Paper
              elevation={0}
              sx={{
                p: { xs: 2, md: 3 },
                backgroundColor: Colors.bg.paper,
                border: `1px solid ${Colors.border.light}`,
                borderRadius: 3,
                boxShadow: Colors.shadow.brand,
              }}
            >
              {right}
            </Paper>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}